import { plainName } from "../../lib/program-names";

import type { CogentWidgetProps } from "../widget-types";
import s from "../cogent.module.css";

type Cogent = NonNullable<CogentWidgetProps["cogent"]>;

const machineSegment =
  /(?:[-_.]|(?<![0-9a-z]))(?:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}|(?=[0-9a-f]{12})[0-9a-f]{8,}|(?=[0-9a-f]*[a-f])[0-9a-f]{8,})(?![0-9a-z])/gi;

function PlaceProgram({
  program,
}: {
  program: NonNullable<Cogent["program"]>;
}) {
  const label = plainName(program.label);
  const at = label.lastIndexOf(":");
  const full = at > 0 ? label.slice(0, at) : label;
  const version = at > 0 ? label.slice(at) : "";
  const shorter = full.replace(machineSegment, "\u2026");
  const name = shorter === "\u2026" ? full : shorter;

  return (
    <span className={s.placeProgram} data-testid="cogent-program" title={label}>
      <span className={s.placeSep}>{"\u00a0·\u00a0"}</span>
      <code className={s.placeCode}>
        <span className={s.placeProg}>{name}</span>
        <span className={s.placeVersion}>{version}</span>
      </code>
      {program.rank ? (
        <span className={s.placeRank}>
          {`\u00a0· rank ${program.rank}`}
          {program.of != null && program.of >= program.rank ? (
            <span className={s.placeOf}>{`\u00a0of ${program.of}`}</span>
          ) : null}
        </span>
      ) : (
        <span className={s.placeRank}>{"\u00a0· not ranked yet"}</span>
      )}
    </span>
  );
}

export function WidgetPlace({
  cogent,
  coworld,
}: {
  cogent: Cogent;
  coworld: CogentWidgetProps["coworld"];
}) {
  return (
    <p
      className={s.place}
      data-testid="cogent-where"
      data-where={coworld.joinHref ? "away" : "here"}
    >
      <span className={s.placeCoworld}>
        {coworld.joinHref ? "Not in " : "In "}
        <b>{coworld.name}</b>
        {coworld.joinHref ? " yet" : ""}
      </span>
      {cogent.lastActive ? (
        <span className={s.placeName} data-testid="cogent-last-active">
          {"\u00a0· last active in "}
          {cogent.lastActive.href ? (
            <a href={cogent.lastActive.href}>{cogent.lastActive.name}</a>
          ) : (
            cogent.lastActive.name
          )}
        </span>
      ) : null}
      {cogent.program ? <PlaceProgram program={cogent.program} /> : null}
    </p>
  );
}
